import { Component } from '@angular/core';

@Component({
  selector: 'bp-profiles-invoice',
  template: `
    <ui-view></ui-view>
  `
})
export class BPProfilesInvoiceComponent { }